import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Portal from 'react-portal';
import _round from 'lodash/round';
import Button from 'components/Button';

import './style.scss';

const MODAL_HEIGHT = 100;
const SMALL_GAP = 5;
const LARGE_GAP = 80;

export const getNewTop = (docHeight, top) =>
  docHeight - MODAL_HEIGHT > top
    ? `${_round(top) + SMALL_GAP}px`
    : `${_round(docHeight) - LARGE_GAP}px`;

export default class RuleGroupActionsMenu extends Component {
  static propTypes = {
    onClose: PropTypes.func,
    onOpenDeleteModal: PropTypes.func,
    onOpenAddModal: PropTypes.func,
  };

  state = {
    position: {},
  };

  componentDidMount() {
    if (this.ref) {
      this.getPosition(this.ref);
    }
  }

  getPosition = domElement => {
    const { top, left } = domElement.getBoundingClientRect();
    const docHeight = document.documentElement.offsetHeight;
    const newTop = getNewTop(docHeight, top);

    this.setState({
      position: {
        top: newTop,
        left: `${_round(left) - LARGE_GAP}px`,
      },
    });
  };

  handleOpenActionAndClose = () => {
    this.props.onClose();
    this.props.onOpenAddModal();
  };

  handleDeleteActionAndClose = () => {
    this.props.onClose();
    this.props.onOpenDeleteModal();
  };

  handleRefWrap = ref => {
    this.ref = ref;
  };

  render() {
    return (
      <div styleName="menu" ref={this.handleRefWrap}>
        <Portal
          isOpened
          closeOnEsc
          closeOnOutsideClick
          onClose={this.props.onClose}
        >
          <div style={this.state.position} styleName="options">
            <Button
              isTransparent
              onClick={this.handleOpenActionAndClose}
              data-test="add"
            >
              Add Rule
            </Button>
            <Button
              isTransparent
              onClick={this.handleDeleteActionAndClose}
              data-test="delete"
            >
              Delete
            </Button>
          </div>
        </Portal>
      </div>
    );
  }
}
